import { SafeError, SafePromise } from '@benzinga/safe-await';
import { ListenableSubscribable } from '@benzinga/subscribable';
import { Session } from '@benzinga/session';
import { Event } from './entities';
import { EventsRestful } from './restful';

interface ErrorEvent {
  error: SafeError;
  errorType: 'get_events_error';
  type: 'error';
}

interface GetEventsEvent {
  events: Event | Event[];
  type: 'get_events';
}

export type EventsRestfulEvent = ErrorEvent | GetEventsEvent;

export class EventsRequest extends ListenableSubscribable<EventsRestfulEvent> {
  private restful: EventsRestful;

  constructor(session: Session) {
    super();
    this.restful = new EventsRestful(session);
  }

  public getEvent = async (postId: number): SafePromise<Event> => {
    const response = await this.restful.getEvent(postId);
    if (response.err) {
      this.dispatch({
        error: response.err,
        errorType: 'get_events_error',
        type: 'error',
      });
    } else {
      this.dispatch({
        events: response.ok,
        type: 'get_events',
      });
    }
    return response;
  };

  public getEvents = async (): SafePromise<Event[]> => {
    const response = await this.restful.getEvents();
    if (response.err) {
      this.dispatch({
        error: response.err,
        errorType: 'get_events_error',
        type: 'error',
      });
    } else {
      this.dispatch({
        events: response.ok,
        type: 'get_events',
      });
    }
    return response;
  };
}
